/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_OperabilityInputs */

const en_directory_agent_readiness_operability = /** @type {(inputs: Directory_Agent_Readiness_OperabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operability`)
};

const zh_directory_agent_readiness_operability = /** @type {(inputs: Directory_Agent_Readiness_OperabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可操作性`)
};

/**
* | output |
* | --- |
* | "Operability" |
*
* @param {Directory_Agent_Readiness_OperabilityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_operability = /** @type {((inputs?: Directory_Agent_Readiness_OperabilityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_OperabilityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_operability(inputs)
	return zh_directory_agent_readiness_operability(inputs)
});
export { directory_agent_readiness_operability as "directory.agent_readiness.operability" }